/* eslint-disable @typescript-eslint/naming-convention */

import { gql } from "@apollo/client";
import { PostInfoV2WithDerivatives } from "./fragments";

export const GetPostV2 = /* GraphQL */ gql`
  ${PostInfoV2WithDerivatives}
  query Get_Post_V2($postId: ID!) {
    getPost(id: $postId) {
      ...PostInfoV2WithDerivatives
    }
  }
`;

export const GetPostRepliesPaginatedV2 = gql`
  ${PostInfoV2WithDerivatives}
  query GetPostRepliesPaginated($postId: ID!, $nextPageToken: String) {
    getPost(id: $postId) {
      replies(limit: 1000, nextToken: $nextPageToken) {
        nextToken
        items {
          ...PostInfoV2WithDerivatives
        }
      }
    }
  }
`;

export const GetPostEchoesPaginatedV2 = gql`
  ${PostInfoV2WithDerivatives}
  query GetPostEchoesPaginated($postId: ID!, $nextPageToken: String) {
    searchPosts(
      limit: 1000
      nextToken: $nextPageToken
      filter: { repostedPost_id: { eq: $postId } }
    ) {
      nextToken
      items {
        ...PostInfoV2WithDerivatives
      }
    }
  }
`;
